<template>
  <div class="box">
    <div class="contentCard">
      <div class="title">
        <p></p>
        <span>项目详情</span>
        <div @click="importExcel">
          <img src="../../assets/img/statistics1.png" alt="" />导出
        </div>
      </div>
      <div class="content">
        <el-table :data="tableData" style="width: 100%">
          <!-- 团队长看业务员 -->
          <el-table-column
            v-if="userInfos[0].roleKey == 'group'"
            prop="grantUserName"
            label="业务员"
          >
          </el-table-column>
          <!-- 团队经理看团队长 -->
          <el-table-column
            v-else-if="userInfos[0].roleKey == 'siteManage'"
            prop="teamName"
            label="团队长"
          >
          </el-table-column>
          <!-- 经营单位看团队经理 -->
          <el-table-column
            v-else-if="userInfos[0].roleKey == 'busiUnit'"
            prop="manageName"
            label="团队经理"
          >
          </el-table-column>
          <!-- 市公司看经营单位 -->
          <el-table-column
            v-else-if="userInfos[0].roleKey == 'city'"
            prop="unitName"
            label="经营单位"
          >
          </el-table-column>
          <!-- 省公司看市公司 -->
          <el-table-column
            v-else-if="userInfos[0].roleKey == 'province'"
            prop="cityName"
            label="市公司"
          >
          </el-table-column>
          <el-table-column prop="grantDate" label="发放日期"> </el-table-column>
          <el-table-column prop="userName" label="用户">
            <template slot-scope="scope">
              <div style="display: flex; flex-direction: column">
                <span>{{ scope.row.userName }}</span>
                <span>{{ scope.row.carNumber }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="tableScope2" v-if="scope.row.unifiedStatus">
                <el-tag v-if="scope.row.unifiedStatus == 'US01'" size="small">{{
                  scope.row.unifiedStatusLabel
                }}</el-tag>
                <el-tag
                  type="success"
                  v-else-if="scope.row.unifiedStatus == 'US02'"
                  size="small"
                  >{{ scope.row.unifiedStatusLabel }}</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="scope.row.unifiedStatus == 'US03'"
                  size="small"
                  >{{ scope.row.unifiedStatusLabel }}</el-tag
                >
                <el-tag
                  type="info"
                  v-else-if="scope.row.unifiedStatus == 'US04'"
                  size="mini"
                  >{{ scope.row.unifiedStatusLabel }}</el-tag
                >
                <el-tag type="danger" v-else size="small">{{
                  scope.row.unifiedStatusLabel
                }}</el-tag>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 自定义时间 -->
    <van-calendar
      v-model="show"
      type="range"
      @confirm="onConfirm"
      color="#FC9023"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>
<script>
import {
  countAnalysisDetail,
  exportCountAnalysisDetail,
  download
} from "@/api/statistics";
import { exportExcel } from "@/utils/down.js";
export default {
  data() {
    return {
      tableData: [],
      ids: {
        couponId: this.$route.query.couponId,
        // serveId: this.$route.query.serveId,
        isPage: false,
      },
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      userInfos: "",
      show: false,
      minDate: new Date(2020, 0, 1), //日期可选最小值
      maxDate: new Date(), //日期可选最大值
      startTime: "",
      endTime: "",
    };
  },
  created() {
    this.userInfos = JSON.parse(this.userInfo.roleList);
    countAnalysisDetail(this.ids).then((res) => {
      if (res.code == 200) {
        this.tableData = res.rows;
      }
    });
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.startTime = this.getNowFormatDate(date[0]);
      this.endTime = this.getNowFormatDate(date[1]);
      this.ids.startDate = this.startTime;
      this.ids.endDate = this.endTime;
      exportCountAnalysisDetail(this.ids).then((res) => {
        if (res.code == 200) {
          let datas = {
            delete: true,
            fileName: res.msg,
          };
          download(datas).then((response) => {
            exportExcel(response, "统计分析详情.xlsx");
          });
        } else {
          this.$toast({ message: res.msg, position: "top" });
        }
      });
    },
    //获取当前日期函数
    getNowFormatDate(val) {
      let date = val,
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`;
    },
    // 导出
    importExcel() {
      this.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  min-height: calc(100vh - 44px);
  // min-height: 100vh;
  // background: #f4f8fb;
  padding: 10px 9px 17px 10px;
  box-sizing: border-box;

  .contentCard {
    width: 100%;
    padding: 0 0 12px 0;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 4px;
      padding: 13px 21px 13px 0;

      p {
        margin: 0;
        width: 4px;
        height: 20px;
        background: linear-gradient(180deg, #fc9a19 0%, #fe6b49 100%);
      }

      span {
        font-size: 18px;
        color: #2c394d;
        margin-left: 9px;
      }

      div {
        font-size: 11px;
        color: #fc9a19;
        display: flex;
        align-items: center;
        margin-left: auto;

        img {
          margin-right: 3px;
        }
      }
    }

    .content {
      background: #ffffff;
      border-radius: 4px;
      padding: 10px;
      margin-top: 10px;

      :deep .el-table {
        .el-table__cell {
          .cell {
            padding-right: 0;
          }
        }
        .el-table__header {
          .is-leaf {
            border-top: 1px solid #ebeef5;
          }

          .cell {
          }
        }

        .el-table__row .cell {
          color: #666666;
        }

        .el-button {
          color: #fc9023;
        }
      }
    }
  }
}
</style>
